import { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { CurrentUserContext } from 'Components/Participant/Auth/RequiresCurrentUserContext';

import LabelledInput from 'Components/Form/LabelledInput';
import Error from 'Components/Form/Error';

import { registerConfirmation } from 'cognito/auth';

const CODE_PATTERN = /^[0-9]{1,8}$/;

function RegisterConfirmation ()
{
    const { onLoggedIn } = useContext ( CurrentUserContext );

    const navigate = useNavigate ();

    const email = localStorage.getItem ( "email" ) ? localStorage.getItem ( "email" ) : "";
    const [ code, setCode ] = useState ( "" );

    const [ isLoading, setIsLoading ] = useState ( false );
    const [ error, setError ] = useState ( { isError: false, message: null } );

    const doConfirm = async () =>
    {
        setError ( { isError: false, message: null } );
        setIsLoading ( true );

        try
        {
            const result = await registerConfirmation ( email, code.trim () );
            setError ( { isError: false, message: null } );
            setIsLoading ( false );

            if ( result.isSignUpComplete && result.isSignedIn )
            {
                onLoggedIn ();
                navigate ( '/participant/secure/log' );
            }
            else
            {
                navigate ( '/participant/login' );
            }
        }
        catch ( error )
        {
            if ( error.name === "CodeMismatchException" )
            {
                setError ( { isError: true, message: "Incorrect code" } )
            }
            else
            {
                setError ( { isError: true, message: JSON.stringify ( error ) } );
            }

            setIsLoading ( false );
        }
    }

    const isCodeValid = () =>
    {
        return CODE_PATTERN.test ( code );
    }

    return  <div className="w-full sm:w-4/6 md:w-3/6 m-auto">

                <h1>Thank you for registering!</h1>
                
                <p className="mb-4">Email: {email}</p>
                <form>
                    { error.isError && <Error message={error.message} /> }
                    <LabelledInput id="code" label="Enter the code we've emailed" value={code} onChange={ ( newValue ) => setCode ( newValue ) } type="email" />
                    <div className="flex-row gap-8">
                        <button onClick={ () => doConfirm () } disabled={ !isCodeValid () || isLoading } type="submit">Confirm</button>
                        <Link to="/participant/register">Back to register</Link>
                    </div>
                </form>
            </div>
}

export default RegisterConfirmation;